// extracted by mini-css-extract-plugin
export default {"videoPlaceholder":"VideoPlayer_videoPlaceholder__HNiX9"};